import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';

interface DrawExplainerProps {
  cryptoComEnabled: boolean;
}

export const DrawExplainer = ({ cryptoComEnabled }: DrawExplainerProps) => {
  const { t } = useTranslation('product');

  return (
    <div className="mb-6">
      <div className="flex flex-col gap-y-3">
        <p className="whitespace-pre-line">
          {cryptoComEnabled ? (
            <Trans i18nKey="drawExplainer.crypto">
              A draw is when we select buyers at random, so everyone gets a fair
              chance to buy the artwork. The number of artworks available in the
              draw is indicated on the product page. To learn more about our
              allocation practices, check our{' '}
              <Link
                className="hyperlink"
                href="/support/allocation"
                target="_blank"
              >
                FAQs
              </Link>
              .<br />
              <br />
              Everyone who enters the draw has an equal chance of winning,
              although we may remove entries if we believe that they are in
              breach of our terms and conditions.
              <br />
              <br />
              When you enter the draw, you add your shipping and payment details
              up front. If your draw entry is not picked, you’re not charged.
              <br />
              <br />
              On this draw, you can also choose to pay with crypto, in which
              case we will ask you to complete your payment on the moment of
              entry. If you loose the draw or cancel your entry before the draw
              is run, you’ll be refunded. We’ll email you the results shortly
              after the draw closes.
            </Trans>
          ) : (
            <>
              {t('drawExplainer.intro')}
              <Trans i18nKey="drawExplainer.allocation">
                To learn more about our allocation practices, check our{' '}
                <Link
                  className="hyperlink"
                  href="/support/allocation"
                  target="_blank"
                >
                  FAQs
                </Link>
                .
              </Trans>
            </>
          )}
        </p>
        {cryptoComEnabled ? null : (
          <>
            <p>{t('drawExplainer.entries')}</p>
            <p>{t('drawExplainer.payment')}</p>
          </>
        )}
      </div>
    </div>
  );
};
